import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PenIcon } from '../../appearence/icons/pen_icon';
import { preferencesGroupsStorage } from '../../services/preferencesGroupsStorage';
import {IconWrapper} from "../../appearence/icons/icon_wrapper";

const PreferenceGroupsActionsEditIcon = () => {
    const [isDisabled, setIsDisabled] = useState(true);
    const navigate = useNavigate();

    const changeIsDisabled = () => {
        setIsDisabled(preferencesGroupsStorage.getSelectedList().length !== 1);
    };

    useEffect(() => {
        preferencesGroupsStorage.registerFiltersChangingObserver(changeIsDisabled);
        return () => preferencesGroupsStorage.unRegisterFiltersChangingObserver(changeIsDisabled);
    }, []);

    const navigateOnEditPage = () => {
        if(!isDisabled) {
            navigate(`/preference/group/${preferencesGroupsStorage.getSelectedList()[0].id}`);
        }
    };

    return (
        <li onClick={navigateOnEditPage}>
            <IconWrapper><PenIcon handleClick={navigateOnEditPage}/></IconWrapper>
        </li>
    );
};

export default PreferenceGroupsActionsEditIcon;
